module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('router-link', {
    staticClass: "header__a",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Grid-Awesome")]), _vm._v(" "), _c('router-link', {
    staticClass: "header__a right",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-013d0d14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 70
// module chunks = 1